import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonColor } from '@freelancer/ui/button';
import { Margin } from '@freelancer/ui/margin';

@Component({
  selector: 'app-user-profile-editable-ui-action-row',
  template: `
    <fl-bit class="ActionRow" [ngClass]="{ IsNew: !showDeleteButton }">
      <fl-link
        *ngIf="showDeleteButton"
        [flTrackingLabel]="flTrackingLabel + 'DeleteAction'"
        [disabled]="isBusy"
        (click)="delete.emit()"
      >
        {{ deleteLinkText }}
      </fl-link>
      <fl-bit>
        <fl-button
          i18n="Cancel action button"
          [flTrackingLabel]="flTrackingLabel + 'CancelAction'"
          [disabled]="isBusy"
          [color]="ButtonColor.DEFAULT"
          [flMarginRight]="Margin.SMALL"
          (click)="cancel.emit()"
        >
          Cancel
        </fl-button>
        <fl-button
          i18n="Save action button"
          [flTrackingLabel]="flTrackingLabel + 'SaveAction'"
          [disabled]="disabled"
          [busy]="isBusy"
          [color]="ButtonColor.SECONDARY"
          (click)="save.emit()"
        >
          Save
        </fl-button>
      </fl-bit>
    </fl-bit>
  `,
  styleUrls: ['./user-profile-editable-ui-action-row.component.scss'],
})
export class UserProfileEditableUiActionRowComponent {
  ButtonColor = ButtonColor;
  Margin = Margin;

  @Input() deleteLinkText: string;
  @Input() disabled: boolean;
  @Input() flTrackingLabel: string;
  @Input() isBusy: boolean;
  @Input() showDeleteButton: boolean;

  @Output() cancel = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();
  @Output() save = new EventEmitter<void>();
}
